// Treat empty/blank values as "missing" so fallbacks skip present-but-empty data.
export const isBlank = (v) => {
  if (v === null || v === undefined) return true;
  if (typeof v === 'string') return v.trim() === '';
  if (Array.isArray(v)) return v.length === 0 || v.every(isBlank);
  if (typeof v === 'object') {
    const vals = Object.values(v);
    return vals.length === 0 || vals.every(isBlank);
  }
  return false;
};

// Return the first non-blank value, else undefined.
export const firstNonEmpty = (...vals) => {
  for (const v of vals) {
    if (!isBlank(v)) return v;
  }
  return undefined;
};
